import { graphql } from "gatsby"
import React from "react"

import CoreParagraphAtom from "@atoms/CoreParagraph/CoreParagraph"
import Introduction from "@atoms/Introduction/Introduction"

const CoreParagraph = ({ className, innerHTML, text }) => {
  const isIntroduction = className?.includes("is-style-large")
  return isIntroduction ? (
    <Introduction text={text} />
  ) : (
    <CoreParagraphAtom html={innerHTML} styleName={className} />
  )
}

export const query = graphql`
  fragment CoreParagraph on WpBlockCoreParagraph {
    __typename
    className
    innerHTML
    text
  }
`

export default CoreParagraph
